import { AvailabilityMenu, useRepAvailability } from "@/softphone/availability";
import { AudioSetupButton, PhoneMenu } from "@/softphone/softphone-dock";

/**
 * The phone's own controls over every page but Phone (ACL-553): taking calls, the microphone and
 * speaker, and the phone's options.
 *
 * Taking calls was on the Phone page's strip and inside the phone's popover, so a rep reading a
 * contact had to open the phone to go Ready or take a break, and one who did not find it there
 * stayed in whatever state they were in while calls kept coming. This puts the same control in the
 * same place on every page: the frame's top pane (`FrameTop`). The Phone page draws its fuller
 * strip there itself (`Chrome` in `routes/phone.tsx`), so the shell leaves this off that page.
 *
 * Only for somebody the ACD has a state for (`useRepAvailability`): an admin or a supervisor who
 * staffs no line has nothing to set here, and their pages keep the thin band of frame.
 */
export function TakingCallsStrip() {
  if (useRepAvailability() === null) return null;
  return (
    // As tall as the Phone page's strip, so moving between pages does not move the page under it.
    <div className="flex min-h-12 shrink-0 items-center gap-3 px-4 py-1.5">
      <AvailabilityMenu large />
      <AudioSetupButton />
      <PhoneMenu />
    </div>
  );
}
